<template>
  <v-select
    label="Рабочая область"
    :items="altWAList"
    item-text="DEPT_NAME"
    item-value="DEPT_UUID"
    :value="value"
    @input="sendMessage"
    class="ma-3"
  ></v-select>
</template>

<script>
export default {
  name: 'sysWorkAreaSelect',
  props: {
    value: {
      type: String,
      default: null
    }
  },
  emits: ['input'],
  data () {
    return {
    }
  },
  computed: {
    altWAList: {
      get: function () {
        return this.$store.getters.getCurrentWAList
      }
    }
  },
  methods: {
    sendMessage (val) {
      this.$emit('input', val)
    }
  }
}
</script>
